import React from 'react';
import { graphql } from 'gatsby';
import css from './CalloutSection.module.scss';
import { PrismicRichText } from '@prismicio/react';
import PrismicLink from '../../../PrismicLink/PrismicLink';
import { isFilled } from '@prismicio/helpers';
import cn from 'classnames';

const CalloutSection = ({ slice }) => {
  return (
    <div className={css.container}>
      <div
        className={cn(css.card, {
          [css.twoColumns]: slice.primary.layout_columns === 'two',
        })}
      >
        {slice.primary.layout_columns === 'two' ? (
          <div>
            <p className={css.eyebrow}>{slice.primary.eyebrow}</p>
          </div>
        ) : null}

        <div>
          <div>
            {slice.primary.layout_columns !== 'two' ? (
              <div>
                <p className={css.eyebrow}>{slice.primary.eyebrow}</p>
              </div>
            ) : null}
            {isFilled.richText(slice.primary.title.richText) ? (
              <div className={css.title}>
                <PrismicRichText field={slice.primary.title.richText} />
              </div>
            ) : null}

            <div className={css.description}>
              <PrismicRichText field={slice.primary.description.richText} />
            </div>
          </div>
          <div className={css.link}>
            {isFilled.keyText(slice.primary.cta_text) ? (
              <>
                <PrismicLink to={slice.primary.cta_link?.url}>
                  {slice.primary.cta_text}
                  <svg width="15" height="9.374" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="m14.725 5.35-3.75 3.75a.937.937 0 1 1-1.326-1.326L11.8 5.625H.937A.943.943 0 0 1 0 4.661c0-.545.42-.91.938-.91H11.8L9.65 1.6A.937.937 0 1 1 10.977.274l3.75 3.75a.938.938 0 0 1-.002 1.325Z"
                      fill="#FF5257"
                      fill-rule="nonzero"
                    />
                  </svg>
                </PrismicLink>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export const query = graphql`
  fragment FeatureHighlightPageDataBodyCalloutSection on PrismicFeatureHighlightPageDataBodyCalloutSection {
    primary {
      eyebrow
      title {
        richText
      }
      description {
        richText
      }
      cta_text
      cta_link {
        url
      }
    }
  }
  fragment HomepageDataBodyCalloutSection on PrismicHomepageDataBodyCalloutSection {
    primary {
      layout_columns
      eyebrow
      title {
        richText
      }
      description {
        richText
      }
      cta_text
      cta_link {
        url
      }
    }
  }
  fragment LandingPageDataBodyCalloutSection on PrismicLandingPageDataBodyCalloutSection {
    primary {
      layout_columns
      eyebrow
      title {
        richText
      }
      description {
        richText
      }
      cta_text
      cta_link {
        url
      }
    }
  }
`;

export default CalloutSection;
